import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  BotaoCartaoPadrao,
  BotaoDefinirCartaoPadrao,
  Cabecalho,
  Container,
  Footer,
  TextoBotaoCartaoPadrao,
  TextoBotaoDefinirCartaoPadrao,
  TextoCabecalho,
  TextoNumero,
} from "./styles";
import { faEdit, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { IconeBotao } from "../../pages/selecaoEmpresas/styles";
import { useTheme } from "@emotion/react";
import {
  BotaoVermelhoPreenchido,
  BotaoVermelhoSemFundo,
  BotaoVermelhoVazado,
} from "../Botao";
import { CampoDeInputNumericoComSetas } from "../CampoInput";
import { GerarModalConfirmacao } from "../PopUpConfirmacao";
import ModalCadastrarCartao from "../../pages/gerenciamentoAssinaturaPlanos/cartoes/cadastrarCartao/CadastrarCartao";

export function Cartao({
  nome,
  numero,
  id,
  cartaoPadrao = false,
  onRemove,
  finalizarCompra = false,
  cartaoSelecionado = false,
  trocarCartaoSelecionado,
  onClickDefinirComoPadrao,
  editavel = false,
  onEditar = () => {},
}) {
  const theme = useTheme();

  function BotaoRemover() {
    return (
      <GerarModalConfirmacao
        trigger={
          <IconeBotao>
            <FontAwesomeIcon
              icon={faTrashCan}
              style={{ color: theme.cores.semanticDanger2 }}
            />
          </IconeBotao>
        }
        titulo="Remover cartão"
        subTitulo="Tem certeza que deseja remover o cartão?"
        botaoCancelar={(fechar) => (
          <BotaoVermelhoVazado texto="Cancelar" tamanho="MD" onClick={fechar} />
        )}
        botaoConfirmar={(fechar) => (
          <BotaoVermelhoPreenchido
            texto="Remover"
            tamanho="MD"
            onClick={() => onRemove(fechar)}
          />
        )}
      />
    );
  }

  function BotaoEditar() {
    return (
      <ModalCadastrarCartao
        componenteTrigger={
          <IconeBotao>
            <FontAwesomeIcon
              icon={faPen}
              style={{ color: theme.cores.actionHover2 }}
            />
          </IconeBotao>
        }
        onCadastradoComSucesso={() => onEditar()}
        dadosEditar={{
          numero: numero,
          nome: nome,
          id: id,
        }}
      />
    );
  }

  return (
    <>
      {!finalizarCompra ? (
        <Container>
          <Cabecalho>
            <TextoCabecalho>{nome}</TextoCabecalho>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 8,
              }}
            >
              {editavel && <BotaoEditar />}
              <BotaoRemover />
            </div>
          </Cabecalho>
          <TextoNumero style={{ alignSelf: "start" }}>
            *** *** *** *** {numero}
          </TextoNumero>
          <Footer>
            {cartaoPadrao ? (
              <BotaoCartaoPadrao>
                <TextoBotaoCartaoPadrao>Cartão Padrão</TextoBotaoCartaoPadrao>
              </BotaoCartaoPadrao>
            ) : (
              <BotaoDefinirCartaoPadrao>
                <TextoBotaoDefinirCartaoPadrao
                  onClick={onClickDefinirComoPadrao}
                >
                  Definir como cartão padrão
                </TextoBotaoDefinirCartaoPadrao>
              </BotaoDefinirCartaoPadrao>
            )}
          </Footer>
        </Container>
      ) : (
        <Container
          onClick={trocarCartaoSelecionado}
          style={{ background: theme.cores.neutral40, cursor: "pointer" }}
        >
          <Cabecalho>
            <TextoCabecalho>{nome}</TextoCabecalho>
            {cartaoSelecionado ? (
              <BotaoCartaoPadrao>
                <TextoBotaoCartaoPadrao>
                  Cartão Selecionado
                </TextoBotaoCartaoPadrao>
              </BotaoCartaoPadrao>
            ) : (
              <div style={{ display: "none" }}></div>
            )}
          </Cabecalho>
          <TextoNumero>*** *** *** *** {numero}</TextoNumero>
        </Container>
      )}
    </>
  );
}
